// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import router from './router'
import Vant from 'vant';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/styles/main.css'
import store from "./store/user";

import 'vant/lib/index.css';
import lodash from 'lodash'
import moment from 'moment'
moment.locale('zh-cn');
Vue.prototype.$moment = moment;

Vue.use(ElementUI)
Vue.use(Vant);
Vue.config.productionTip = false

Vue.use(Router);
Vue.prototype._ = lodash;
import { Notify } from 'vant';
Vue.prototype.$notify = Notify
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js